import { Direction } from '@angular/cdk/bidi';
import { Component, Inject, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { QueryParamsService } from 'src/app/@shared/services/query-params/query-params.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { CLOSE, PICK_DESTINATION, PICK_ORIGIN, PICK_STATION, PICK_STOP, RATINGS, STATION_CODE } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { eTab } from 'src/app/modules/route-planner/enums/route-planning/tabs/tabs.enums';
import { Stop } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/stop.interface';
import { StopFullData } from 'src/app/modules/route-planner/interfaces/route-planning/service/@schedule-service.interface';
import { FavoritesService } from 'src/app/modules/route-planner/services/favorites/favorites.service';
import { MAP_OBJECT_TOKEN } from 'src/app/modules/route-planner/services/map/map.service';

@Component({
    selector: 'app-stations-auto-complete-map-marker',
    templateUrl: './stations-auto-complete-map-marker.component.html',
    styleUrl: './stations-auto-complete-map-marker.component.scss',
    standalone: false
})
export class StationsAutoCompleteMapMarkerComponent implements OnInit {
  direction: Direction = this.languageService.getSelectedLanguage().direction;
  isFavoriteStation: boolean;
  stationCodeText: any;
  showPickStationButton: boolean = false
  pickStationText: string
  ratingsText: string;
  closeText: string;
  stationName: string;
  originButtonTitle: string;
  destinationButtonTitle: string;
  addStopButtonTitle: string;
  showAddStopButton: boolean;
  constructor(
    private readonly favoritesService: FavoritesService,
    private readonly languageService: LanguageService,
    private readonly queryParamsService: QueryParamsService,
    private readonly resizeService: ResizeService,

    @Inject(MAP_OBJECT_TOKEN)
    public readonly data: { stop: StopFullData, showOriginDestinationButtons: boolean, showAddStopButton: boolean, showPickStationButton: boolean },
  ) {

  }
  ngOnInit(): void {

    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction
      this.stationCodeText = STATION_CODE[language.language]
      this.pickStationText = PICK_STATION[language.language]
      this.ratingsText = RATINGS[language.language];
      this.closeText = CLOSE[language.language];
      this.stationName = this.data.stop.name[language.symbol] || this.data.stop.name.he || '';

      this.originButtonTitle = PICK_ORIGIN[language.language];
      this.destinationButtonTitle = PICK_DESTINATION[language.language];
      this.addStopButtonTitle = PICK_STOP[language.language];
      this.showAddStopButton = this.data.showAddStopButton;
    });
    this.isFavoriteStation =
      !!this.favoritesService.favorites?.stations?.stations?.find(
        (favoriteStation) => favoriteStation.stopcode === this.data.stop.stopcode);

    this.showPickStationButton = this.shouldShowPickStationButton();
  }

  private shouldShowPickStationButton(): boolean {
    const params = this.queryParamsService._currentParams;
    return this.data.showPickStationButton && params["poiSelectedIndex"] == null;
  }

  shouldShowPickOriginDestinationButtons(): boolean {
    return this.data.showOriginDestinationButtons && !this.data.showPickStationButton;
  }

  get isMobile() {
    return this.resizeService.isMobile
  }
}
